import React from "react";
import "./styles.css";

const DotsLoader = ({ className = "" }) => {
  return (
    <div className={`dots-loader ${className}`}>
      <span className="dots-loader__dot" />
      <span className="dots-loader__dot" />
      <span className="dots-loader__dot" />
    </div>
  );
};

export default DotsLoader;
